import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Header from "../components/header/header"
import Hero from "../components/mobile-first-page/hero"
import MobileFirstSec123 from "../components/mobile-first-page/mobilefirst-sec1-3"
import MobileFirstSec4 from "../components/mobile-first-page/mobilefirst-sec4"
import StickyNav from "../components/sticky-nav"

const MobileFirstPage = () => (
    <Layout>
      <SEO title="Mobile First" />
      <Header />
      <Hero />
      <MobileFirstSec123 />
      <MobileFirstSec4 />
      <StickyNav />
    </Layout>
  )
  
  export default MobileFirstPage